// eslint-disable-next-line
import {UserLayout, BasicLayout, RouteView, BlankLayout, PageView} from '@/layouts'

export const asyncRouterMap = [

  {
    path: '/',
    name: 'index',
    component: BasicLayout,
    children: [
      // 3D 运行大屏：默认主页。放在 '/' 的 children 里是为了进侧栏菜单（菜单只读这一层），
      // 页面自带读数区，不套 PageView 的标题栏
      // keepAlive 必须显式关：RouteView 的 prop 默认值就是 true，否则离开这一页不销毁，
      // WebGL 上下文和 60s 轮询会在后台一直跑着
      {
        path: '/dashboard3d',
        name: 'dashboard3d',
        component: resolve => require(['@/views/dashboard/Dashboard3d'], resolve),
        meta: { title: 'menu.dashboard3d', icon: 'icon-yibiaopan', keepAlive: false }
      },
      // dashboard
      {
        path: '/record',
        name: 'record',
        redirect: '/test/record',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.record', keepAlive: true, icon: 'icon-jilu', permission: ['record'] },
        children: [
          {
            path: '/test/record',
            name: 'TestRecord',
            component: resolve => require(['@/views/data/TestRecord'], resolve),
            meta: { title: 'menu.record', keepAlive: true, permission: ['record'] }
          }
        ]
      },
      {
        path: '/daily',
        name: 'daily',
        redirect: '/daily/data',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.daily.data', keepAlive: true, icon: 'icon-rili', permission: ['record'] },
        children: [
          {
            path: '/daily/data',
            name: 'DailyData',
            component: resolve => require(['@/views/data/DailyData'], resolve),
            meta: { title: 'menu.daily.data', keepAlive: true, permission: ['record'] }
          }
        ]
      },
       {
        path: '/attendance',
        name: 'attendance',
        redirect: '/attendance/stat',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.attendance', keepAlive: true, icon: 'icon-kaoqin', permission: ['driver'] },
        children: [
          {
            path: '/attendance/stat',
            name: 'AttendanceStat',
            component: resolve => require(['@/views/data/AttendanceStat'], resolve),
            meta: { title: 'menu.attendance', keepAlive: true, permission: ['driver'] }
          }
        ]
      },
      {
        path: '/drivelog',
        name: 'drivelog',
        redirect: '/drive/log',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.drivelog', keepAlive: true, icon: 'icon-hangshijilu', permission: ['driver'] },
        children: [
          {
            path: '/drive/log',
            name: 'DriveLog',
            component: resolve => require(['@/views/data/DriveLog'], resolve),
            meta: { title: 'menu.drivelog', keepAlive: true, permission: ['driver'] }
          }
        ]
      },
      {
        path: '/accident',
        name: 'accident',
        redirect: '/accident/manage',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.accident', keepAlive: true, icon: 'icon-shiguxinxi', permission: ['record'] },
        children: [
          {
            path: '/accident/manage',
            name: 'Accident',
            component: resolve => require(['@/views/data/Accident'], resolve),
            meta: { title: 'menu.accident', keepAlive: true, permission: ['record'] }
          }
        ]
      },
      {
        path: '/training',
        name: 'training',
        redirect: '/training/manage',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.training', keepAlive: true, icon: 'icon-peixun', permission: ['record'] },
        children: [
          {
            path: '/training/manage',
            name: 'Training',
            component: resolve => require(['@/views/data/Training'], resolve),
            meta: { title: 'menu.training', keepAlive: true, permission: ['record'] }
          }
        ]
      },
      {
        path: '/worklog',
        name: 'worklog',
        redirect: '/worklog/manage',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.worklog', keepAlive: true, icon: 'icon-songhuozhong', permission: ['record'] },
        children: [
          {
            path: '/worklog/manage',
            name: 'WorkLog',
            component: resolve => require(['@/views/data/WorkLog'], resolve),
            meta: { title: 'menu.worklog', keepAlive: true, permission: ['record'] }
          }
        ]
      },
      {
        path: '/driver',
        name: 'driver',
        redirect: '/driver/list',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.driver', keepAlive: true, icon: 'icon-changyonglvyouyewutubiao_fuzhi_sidao', permission: ['driver'] },
        children: [
          {
            path: '/driver/list',
            name: 'DriverList',
            component: resolve => require(['@/views/data/DriverList'], resolve),
            meta: { title: 'menu.driver', keepAlive: true, permission: ['driver'] }
          }
        ]
      },
      {
        path: '/organization',
        name: 'organization',
        redirect: '/organization/manage',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.organization', keepAlive: true, icon: 'icon-zuzhijiagou', permission: ['record'] },
        children: [
          {
            path: '/organization/manage',
            name: 'Organization',
            component: resolve => require(['@/views/data/Organization'], resolve),
            meta: { title: 'menu.organization', keepAlive: true, permission: ['record'] }
          }
        ]
      },
      {
        path: '/webhook',
        name: 'webhook',
        redirect: '/web/hook',
        component: RouteView,
        hideChildrenInMenu: true,
        meta: { title: 'menu.webhook', keepAlive: true, icon: 'icon-webhook', permission: ['record'] },
        children: [
          {
            path: '/web/hook',
            name: 'WebHook',
            component: resolve => require(['@/views/data/WebHook'], resolve),
            meta: { title: 'menu.record', keepAlive: true, permission: ['record'] }
          }
        ]
      },

      // 默认主页必须声明在上面那条 '*' 之前，顺序反了就不生效：
      // vue-router 3 给父级建 record 时是先把 children 逐个注册完、再注册父级自己，
      // 而匹配是按注册顺序取第一个正则命中的 record，命中后直接用它的 redirect；
      // '*' 归一化成 '/*' 后连 '/' 都能匹配，所以清掉地址栏路径进根目录会被它抢去 /404，
      // 父级那个 redirect 压根轮不到，而 404 页的 created 里又按“有没有司机快过期”硬跳 /driver/list
      // 空 path 归一化后就是 '/'，只吃这一个精确路径，比 '/*' 先注册就赢，其余野路径照旧走 /404
      {
        path: '', name: 'home', redirect: '/dashboard3d', hidden: true
      },
      {
        path: '*', redirect: '/404', hidden: true
      }
    ],
    meta: { title: '' },
    redirect: '/dashboard3d'
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/u',
    component: UserLayout,
    redirect: '/u/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: resolve => require(['@/views/user/Login'], resolve)
      },
      {
        path: 'register',
        name: 'register',
        component: resolve => require(['@/views/user/Register'], resolve)
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: resolve => require(['@/views/user/RegisterResult'], resolve)
      }
    ]
  },
  {
    path: '/bind',
    component: BlankLayout,
    redirect: '/bind/driver',
    hidden: true,
    children: [{
      path: '/bind/driver',
      name: 'bind',
      component: resolve => require(['@/views/driver/BindDriver'], resolve)
    }]
  },
  {
    path: '/404',
    component: resolve => require(['@/views/exception/404'], resolve)
  }

]
